import {AfterContentInit, Component, Inject} from '@angular/core';
import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatListModule} from "@angular/material/list";
import {CommonModule} from "@angular/common";
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from "@angular/material/dialog";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatInputModule} from "@angular/material/input";
import {FormsModule} from "@angular/forms";
import {MatButtonModule} from "@angular/material/button";
import {MatIconModule} from "@angular/material/icon";
import {MatOptionModule} from "@angular/material/core";
import {MatSelectModule} from "@angular/material/select";
import {HttpService} from "../../services/http/http.service";
import {MatSnackBar} from "@angular/material/snack-bar";

@Component({
  selector: 'carica-documento-dialog',
  templateUrl: './carica-documento-dialog.component.html',
  styleUrls: ['./carica-documento-dialog.component.scss'],
  standalone: true,
  imports: [MatRadioModule, MatDatepickerModule, MatListModule, CommonModule, MatDialogModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, MatOptionModule, MatSelectModule],
})
export class CaricaDocumentoDialog implements AfterContentInit {
  listaCompetenze: any;
  constructor(
    public dialogRef: MatDialogRef<CaricaDocumentoDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public api: HttpService,
    private snackBar: MatSnackBar,
  ) { }

  ngAfterContentInit(): void {

  }

  onFileSelected(event: any, id: any) {

    const file: File = event.target.files[0];

    if (file) {
      this.api.uploadDocumento(file, id).subscribe({
        next: (response: any) => {
          this.data.details.idDocumento = response.result.valore;
        }
      });
    }

  }
  downloadDecreto(id: any) {
    let data = {
      valore: id
    }
    this.api.downloadDocumento(data).subscribe(
      (data:any) => {
        let fileName: string = "Documento.pdf";
        this.api.downloadService(data, fileName);
      }
    )
  }
  save() {
    let date = new Date(this.data.details.dtCaricamento);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    let year = date.getFullYear();
    this.data.details.dtCaricamento = year + '-' + month + '-' + day;
    this.api.salvaAreaCaricamento(this.data.details).subscribe({
      next: (response: any) => {
        this.snackBar.open('Documento salvato con successo', 'close', { panelClass: 'successSnack' });
      },
      complete: () => {
      this.dialogRef.close(true);
    }
    });
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  checkForm() {
    let isDisabled = (!(this.data.details.descrizione && this.data.details.dtCaricamento && this.data.details.idDocumento));
    return isDisabled;
  }
}
